const theme = {
  flexboxgrid: {
    gridSize: 16,
    gutterWidth: '1.3',
    outerMargin: '0',
    mediaQuery: 'only screen',
    container: {
      sm: 46,
      md: 61,
      lg: 76
    },
    breakpoints: {
      xs: 0,
      sm: 53.8,
      md: 61,
      lg: 67
    }
  }
}

export default theme
